/* lettra: gemeinsame Zahlenanzeige fuer beide Konfiguratoren.

   Herausgeloest aus lettra-configurator.js (10. 8.), wo der Preis-Zaehler
   fest an dessen Summen-Element hing. Der Bubble-Konfigurator liess die
   Zahlen deshalb springen, waehrend sie beim Schriftzug hochliefen.

   Kein Modulsystem — das Theme laedt klassische Skripte. Die Datei stellt
   window.LettraZahlen bereit und muss per defer VOR den beiden
   Konfigurator-Skripten stehen (Reihenfolge in den Section-Dateien).

   Motion laut DESIGN.md: Preis-Zaehler 300ms. */
(function () {
  'use strict';

  var DAUER = 300;

  function euro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Ein Zaehler je Element, nicht je Konfigurator: Summe und CTA zeigen
     dieselbe Zahl, laufen aber als zwei getrennte Animationen auf zwei
     Knoten. Ein gemeinsamer Speicher wuerde beide gegeneinander
     abbrechen.
       raf  — laufende Frame-Anforderung, null wenn nichts laeuft
       wert — die Zahl, die gerade im Element steht (siehe zaehleAuf) */
  function neuerZaehler() {
    return { raf: null, wert: 0 };
  }

  function stoppe(zaehler) {
    if (zaehler && zaehler.raf) {
      cancelAnimationFrame(zaehler.raf);
      zaehler.raf = null;
    }
  }

  /* Zaehlt el von zaehler.wert auf zielCents.

     format bestimmt, was im Element steht — Vorgabe ist der reine Betrag.
     Fuer den CTA wird eine Funktion uebergeben, die den Betrag in den
     Satz einsetzt; das Praefix bleibt dabei ueber alle Frames gleich,
     nur die Ziffern aendern sich.

     Bei reduzierter Bewegung und im Hintergrund-Tab wird direkt gesetzt.
     Im Hintergrund pausiert requestAnimationFrame ohnehin — ohne die
     Pruefung liefe die Animation erst beim Zurueckwechseln los, also zu
     einem Zeitpunkt, an dem die Zahl laengst still stehen sollte. */
  function zaehleAuf(el, zaehler, zielCents, format) {
    if (!el || !zaehler) return;
    var schreibe = format || euro;

    /* Abbruch VOR der Bewegungs-Pruefung: Sonst liefe bei mitten in der
       Animation umgestellter Systemeinstellung der alte Frame-Lauf weiter
       und ueberschriebe den direkt gesetzten Endwert im naechsten Frame. */
    stoppe(zaehler);

    if (reducedMotion() || document.hidden) {
      zaehler.wert = zielCents;
      el.textContent = schreibe(zielCents);
      return;
    }

    var von = zaehler.wert;
    var start = performance.now();

    function tick(now) {
      var t = Math.min((now - start) / DAUER, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      var wert = Math.round(von + (zielCents - von) * eased);
      /* Zwischenwert sofort merken, nicht erst am Ende: Wird die Animation
         beim naechsten Tastendruck abgebrochen, setzt die neue bei genau
         der Zahl an, die gerade zu sehen ist. Vorher stand hier nur der
         letzte VOLLSTAENDIG durchgelaufene Wert — bei schneller Eingabe
         sprang die Anzeige damit sichtbar zurueck und lief erneut hoch. */
      zaehler.wert = wert;
      el.textContent = schreibe(wert);
      if (t < 1) {
        zaehler.raf = requestAnimationFrame(tick);
      } else {
        zaehler.wert = zielCents;
        zaehler.raf = null;
      }
    }

    zaehler.raf = requestAnimationFrame(tick);
  }

  /* Bricht eine laufende Animation ab und setzt einen festen Text —
     fuer Zustaende ohne Betrag ("Preis wird geprueft", "In den Warenkorb").
     Damit muss niemand von aussen in zaehler.raf hineingreifen.

     wert ist optional: ohne Angabe bleibt die gemerkte Zahl stehen, der
     naechste Lauf setzt also dort an, wo die Anzeige zuletzt stand. Mit
     Angabe wird sie nachgezogen — noetig, wenn der Text zwar keinen Betrag
     zeigt, der zugehoerige Wert sich aber trotzdem geaendert hat. */
  function festerText(el, zaehler, text, wert) {
    stoppe(zaehler);
    if (zaehler && typeof wert === 'number') zaehler.wert = wert;
    if (el) el.textContent = text;
  }

  window.LettraZahlen = {
    euro: euro,
    reducedMotion: reducedMotion,
    neuerZaehler: neuerZaehler,
    zaehleAuf: zaehleAuf,
    festerText: festerText
  };
})();
